import { forwardRef } from 'react';
import { WeaveTheme } from '@frontend/theme';

export interface SuccessFilledProps extends React.SVGProps<SVGSVGElement> {
  colors: WeaveTheme['colors'];
  primaryColor?: string;
  secondaryColor?: string;
}

const SuccessFilled = forwardRef<SVGSVGElement, SuccessFilledProps>(
  ({ colors, primaryColor, secondaryColor, ...props }, ref) => {
    return (
      <svg {...props} ref={ref} fill='none' viewBox='0 0 24 24'>
        <path
          fill={primaryColor ?? colors.success20}
          d='M22 12.004c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10'
        ></path>
        <path
          fill={secondaryColor ?? '#125F36'}
          fillRule='evenodd'
          d='M17.189 7.676a1.25 1.25 0 0 1 .188 1.757l-5.319 6.593a1.4 1.4 0 0 1-1.998.186l-2.506-2.138a1.25 1.25 0 1 1 1.622-1.902l1.646 1.404 4.609-5.712a1.25 1.25 0 0 1 1.758-.188'
          clipRule='evenodd'
        ></path>
      </svg>
    );
  }
);

SuccessFilled.displayName = 'SuccessFilled';

export default SuccessFilled;
